import React from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import {ActionResult} from "../model";
const ErrorPage = (props: any) => {
    let msg = props.msg;
    let errorCode = props.code ?? 500;
    const act: ActionResult = props.action;
    if (act) {
        msg = act.errorMsg;
        errorCode = act.errorCode;
    }
    if (msg) {
        msg = `${msg}`;
    } else {
        msg = '서버 접속에 문제가 발생하였습니다.';
    }

    function refresh(e: any) {
        e.preventDefault();
        window.location.reload();
    }

    const errorColor = {
        color: 'red'
    };
    const std = {
        paddingTop: 20
    };
    return (
        <div className='container' style={std}>
            <Row>
                <Col sm={12}>
                    <div className="card"><img src="/img/lazyload-ph.png" data-src="/img/image.png"
                                               className="img-fluid mx-auto d-block img-style lazyload"
                                               alt="placeholder user"/>
                        <div className="card-body">
                            <h3 className="text-center">오류코드 : [<span className='text-danger'>{errorCode}</span>]
                            </h3>
                            <h6 className="text-center title6 text-lg-center lr ">
                                <hr/>
                                <span className='text-danger'>{msg}</span>
                                <hr/>
                                새로고침 해보시고 안되시면 저희 고객센터에 문의바랍니다.
                            </h6>
                            <div className="text-center text-lg-center"><a href="#error" onClick={refresh}
                                                                           className="btn btn-d bt btn-lg">새로고침</a>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
    )
}
export default ErrorPage;
